<div class="chart-js-responsive-container">
  <canvas #treemapCanvas></canvas>
</div>
